import { PreviewStatus } from '@/types/coupon-wall';
import React from 'react';



const DEFAULT_PREVIEW_IMAGE_MAP: Record<PreviewStatus, string> = {
  [PreviewStatus.LOADING]: 'https://p1.meituan.net/pepperfe/a32ac97e5d6e5fecfc64b5052e359a09160304.png',
  [PreviewStatus.RECEIVING]: 'https://p0.meituan.net/pepperfe/e37d443668b2626e0484142c1b763717158638.png',
  [PreviewStatus.NOT_LOGIN]: 'https://p1.meituan.net/pepperfe/a32ac97e5d6e5fecfc64b5052e359a09160304.png',
}

/**
 * 红包墙曝光优化
 * - 预发券接口返回前，展示待领券的静态图，点击触发领券，领券时展示领券中的静态图
 */
const PreviewState: React.FC<{
  previewStatus: PreviewStatus;
  previewImageConfig?: Record<PreviewStatus, string>;
  onReceiveCoupon: () => void;
  onLogin: () => void;
}> = (props) => {
  const { previewStatus, previewImageConfig, onReceiveCoupon, onLogin } = props || {};

  const handleClick = () => {
    if (previewStatus === PreviewStatus.LOADING) {
      onReceiveCoupon?.();
    } else if (previewStatus === PreviewStatus.NOT_LOGIN) {
      onLogin?.(); 
    }
  }

  return (
    <div className="coupon-wall-preview" onClick={handleClick}>
      <img src={previewImageConfig?.[previewStatus] || DEFAULT_PREVIEW_IMAGE_MAP[previewStatus]} />
    </div>
  );
};

export default PreviewState;

